import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { StateService } from 'src/app/core/_services/state.service';
import { ClickOutsideDirective } from './../../core/_directives/click-outside-directive';
import { SelectBox } from './../../core/_models/select-box';

@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SelectBoxComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: SelectBoxComponent,
    },
  ],
  viewProviders: [ClickOutsideDirective],
})
export class SelectBoxComponent implements ControlValueAccessor, Validator {
  @Input() set list(input: SelectBox[] | string[]) {
    if (input.length === 0) return;
    if (typeof input[0] === 'string') {
      this._list = (input as string[]).map((item) => {
        return {
          text: item,
          value: item,
        };
      });
    } else {
      this._list = input as SelectBox[];
    }
    this._list.forEach((item) => {
      item.isSelect = false;
    });
  }
  @Input() multiple = true;
  @Input() placeholder = 'Dịch vụ';
  _activePlaceHolder = 'Dịch vụ';
  @ViewChild('selectRef', { static: true }) selectRef!: ElementRef<HTMLElement>;

  _list: SelectBox[] = [];
  selectedItems: string[] = [];
  touched = false;
  disabled = false;
  isOpen = false;

  constructor(private _stateService: StateService) {
    this._stateService.currentLanguage$.subscribe({
      next: (currentLang: string) => {
        if (currentLang === 'en') {
          this._activePlaceHolder = 'Services';
        } else {
          this._activePlaceHolder = 'Dịch vụ';
        }
      },
    });
  }

  onChange = (selectedItems: string[]) => {
    this.writeValue(selectedItems);
  };

  onTouched = () => {
    // Todo
  };

  toggleSelect(item: SelectBox) {
    if (this.disabled) {
      return;
    }
    this.markAsTouched();
    item.isSelect = !item.isSelect;

    // this.removeOrAdd(this.selectedItems, item.value);
    const selectedItems = this._list.filter((item) => item.isSelect).map((item) => item.value);
    this._activePlaceHolder = selectedItems.join(', ') || this.placeholder;
    this.onChange(selectedItems);
  }

  writeValue(selectedItems: string[]) {
    this.selectedItems = selectedItems;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const selectedItems = control.value;
    return null;
    // if (selectedItems.length === 0) {
    //   return {
    //     require: {
    //       selectedItems
    //     }
    //   };
    // }
  }

  private removeOrAdd(arr: string[], selectedItem: string): void {
    const index = arr.indexOf(selectedItem);
    if (index !== -1) {
      arr.splice(index, 1);
    } else {
      arr.push(selectedItem);
    }
  }

  handleClickOutSide(): void {
    this.isOpen = false; // not work ??
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
    this.markAsTouched();
  }

  @HostListener('document:click', ['$event.target'])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public onClick(target: any) {
    const clickedInside = this.selectRef.nativeElement.contains(target);
    if (!clickedInside) {
      this.isOpen = false;
    }
  }
}
